import { initializeI18n } from '~/utils/store-accessor';
export default ({ i18n }) => {
    initializeI18n(i18n);
};
